import { Button } from 'primereact/button';
import styles from "./Wrapper.module.scss";

function AnalyticsSection({ label, actions, children, disable }) {
  return (
    <div className={styles.analyticsSectionWrapper} style={{ pointerEvents: disable ? 'none' : 'auto', filter: disable ? 'grayscale(1)' : 'none' }}>
      <div className={styles.topContainer}>
        <h3 className={styles.sectionTitle}>{label}</h3>
        <div className={styles.sectionActions}>
          {actions &&
            actions.map((action, index) => (
              <Button
                key={index}
                size="small"
                outlined
                rounded
                label={action.label}
                iconPos="left"
                icon={`pi ${action.icon}`}
                onClick={action.onClick}
                className={styles.actionButton}
              />
            ))}
        </div>
      </div>
      <div className={styles.contentContainer}>
        {children}
      </div>
    </div>
  );
}

export default AnalyticsSection;
